<div class="horizontalMenucontainer">
  <!-- <app-switcher></app-switcher> -->
  <div class="page">
    <div class="page-main">
      <app-header></app-header>
      <app-sidebar appHoverEffectSidebar></app-sidebar>
      <div class="jumps-prevent" style="padding-top: 74px;"></div>
      <div class="app-content main-content mt-0">
        <div class="side-app" [ngClass]="{ 'pt-60': scrolled }">
          <div class="main-container container-fluid" (click)="toggleSwitcherBody()">
            <router-outlet>
              <!-- @if (this.SPACES?.includes(this.space?.toString())) {
                <app-closure-banner></app-closure-banner>
              } -->
              <app-loader></app-loader>
            </router-outlet>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
<app-tab-to-top></app-tab-to-top>
@if (isInMaintenanceMode) {
  <app-maintenance></app-maintenance>
}
<!-- @if (showWhatsNew) {
  <app-whats-new (close)="closeWhatsNew()"></app-whats-new>
} -->
<app-snackbar [showSnackbar]="showSnackbar" [message]="message" [snackbarClass]="snackbarClass"></app-snackbar>



